/* eslint-disable code-style/folder-structure-consistency */

export const globalData = {
    breakpoints: { sm: "sm" },
    calendarOpenTo: "day",
    calendarViews: [
        "year",
        "month",
        "day",
        "hours",
        "minutes",
    ],
    colors: {
        error: "error",
        textSecondary: "text.secondary",
    },
    cookieKeys: {
        token: "token",
        user: "user",
        userId: "userId",
    },
    cssValues: {
        calc: "calc(",
        noImportant: "0!important",
        paddingMd: "8px 16px",
        paddingSm: "4px 0",
        pxImportant: "px!important",
        transitionAll: ".3s all",
        whiteBorder: "1px solid #fff",
    },
    eventCreationTypes: {
        copyEvent: "copyEvent",
        titleOnly: "titleOnly",
        useTemplate: "useTemplate",
    },
    eventTypes: {
        headshot: "headshot",
        standard: "standard",
    },
    fieldNames: {
        banners: "banners",
        event: "event",
        label: "label",
        photographers: "photographers",
        status: "status",
        template: "template",
        title: "title",
        type: "type",
        url: "url",
    },
    formTypes: {
        publicForm: "public",
        tablet: "tablet",
    },
    headshotFieldTypes: { dropdown: "dropdown" },
    headshotSubApis: {
        actions: "actions",
        domains: "domains",
        exportPath: "/export",
        guestForm: "guest-form",
        namingConvention: "naming-convident",
        namingFields: "naming-fields",
        retouchRequests: "/retouch-requests",
        setting: "setting",
        toggle: "toggle",
    },
    htmlElements: {
        canvas: "canvas",
        div: "div",
        img: "img",
        main: "main",
        span: "span",
    },
    httpMethods: { httpDelete: "delete" },
    imageFileTypes: {
        jpeg: "jpeg",
        jpg: "jpg",
        png: "png",
        webp: "webp",
    },
    inputTypes: {
        button: "button",
        checkboxType: "checkbox",
        color: "color",
        date: "date",
        email: "email",
        number: "number",
        password: "password",
        select: "select",
        submit: "submit",
        switchType: "switch",
        text: "text",
    },
    mediaTypes: { image: "image" },
    positions: {
        end: "end",
        start: "start",
    },
    propValues: {
        always: "always",
        initial: "initial",
        open: "open",
    },
    responseTypes: {
        blob: "blob",
        json: "json",
    },
    sizes: { xs: "xs" },
    tabParam: "tab",
    themeLocalStorageKey: "theme",
    themeTypes: {
        dark: "dark",
        light: "light",
    },
    transitionProps: {
        margin: "margin",
        width: "width",
    },
};
